module.exports = __webpack_public_path__ + "static/media/banner-music.7cec64fe.png";